import * as React from 'react';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
import { isTesting } from '../../utilities/testAutomation';

const App = () => (
  <div className="calc-soi-app">
    <SectionWrapper isTesting={isTesting} />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.tsx